const Footer = () => {
  return (
    <article className="footer">
      <p>
        © Zoe-Alanah Michelle Robert {new Date().getFullYear()}
      </p>
    </article>
  );
};

export default Footer;
